export default __webpack_public_path__ + "static/media/setting_2.e464343c.png";